import React from "react";

// Blocs de restitution partages (onglet Satisfaction d'un outil, page statistiques).

export function Stars({ score, max = 5 }) {
    if (score == null) {
        return <span className="sat-stars-inline is-off">—</span>;
    }
    const rounded = Math.round(score);
    return (
        <span className="sat-stars-inline" aria-label={`${score} sur ${max}`}>
            {Array.from({ length: max }, (_, index) => (
                <i key={index} className={`pi ${index < rounded ? "pi-star-fill" : "pi-star is-off"}`} aria-hidden="true" />
            ))}
        </span>
    );
}

export function formatScore(value) {
    return value == null ? "—" : `${Number(value).toLocaleString("fr-FR", { maximumFractionDigits: 1 })}/5`;
}

export function formatRate(value) {
    return value == null ? "—" : `${Number(value).toLocaleString("fr-FR", { maximumFractionDigits: 0 })} %`;
}

export function Distribution({ items, reverse = false }) {
    const list = reverse ? [...(items ?? [])].reverse() : (items ?? []);
    if (list.length === 0) {
        return null;
    }
    return (
        <div className="sat-distribution">
            {list.map((item) => (
                <div key={item.label} className="sat-distribution-row">
                    <span>{item.label}</span>
                    <div className="sat-bar"><span style={{ width: `${item.percent ?? 0}%` }} /></div>
                    <small>{item.count} · {Math.round(item.percent ?? 0)} %</small>
                </div>
            ))}
        </div>
    );
}

export function CommentsList({ comments, emptyMessage = "Aucun commentaire pour le moment." }) {
    if (!comments || comments.length === 0) {
        return <p className="sat-empty">{emptyMessage}</p>;
    }
    return (
        <ul className="sat-comments">
            {comments.map((comment, index) => (
                <li key={`${comment.rentalPublicId}-${index}`}>
                    <p>{comment.text}</p>
                    <small>
                        {comment.score != null && <><Stars score={comment.score} /> · </>}
                        {comment.clientName}
                        {comment.toolName ? ` · ${comment.toolName}` : ""}
                        {" · "}{new Date(comment.date).toLocaleDateString("fr-FR")}
                        {comment.rentalPublicId && <> · <a href={`/${comment.rentalPublicId}`}>voir la location</a></>}
                    </small>
                </li>
            ))}
        </ul>
    );
}

export function QuestionResults({ questions }) {
    if (!questions || questions.length === 0) {
        return <p className="sat-empty">Aucune question.</p>;
    }
    return (
        <div className="sat-results-grid">
            {questions.map((question) => (
                <div key={question.publicId} className={`sat-result-card${question.isActive ? "" : " is-inactive"}`}>
                    <h4>
                        {question.label}
                        <small>
                            {question.section === "tool" && question.toolName ? `${question.toolName} · ` : ""}
                            {question.answersCount} réponse{question.answersCount > 1 ? "s" : ""}
                            {question.type === "Rating" && question.average != null ? ` · moyenne ${formatScore(question.average)}` : ""}
                            {question.type === "YesNo" && question.yesRate != null ? ` · ${formatRate(question.yesRate)} de oui` : ""}
                            {!question.isActive ? " · désactivée" : ""}
                        </small>
                    </h4>
                    {question.type === "Text"
                        ? <CommentsList comments={question.textAnswers} emptyMessage="Aucune réponse." />
                        : question.answersCount === 0
                            ? <p className="sat-empty">Pas encore de réponse.</p>
                            : <Distribution items={question.distribution} reverse={question.type === "Rating"} />}
                </div>
            ))}
        </div>
    );
}

export function KpiGrid({ stats }) {
    if (!stats) {
        return null;
    }
    const sent = stats.invitationsSent ?? 0;
    return (
        <div className="sat-kpis">
            <div className="sat-kpi">
                <span>Note moyenne</span>
                <strong>{formatScore(stats.averageScore)}</strong>
                <Stars score={stats.averageScore} />
            </div>
            <div className="sat-kpi">
                <span>Recommandation</span>
                <strong>{formatRate(stats.recommendRate)}</strong>
                <small>recommanderaient le loueur</small>
            </div>
            <div className="sat-kpi">
                <span>Réponses</span>
                <strong>{stats.completedCount ?? 0}</strong>
                <small>{sent > 0 ? `${sent} invitation${sent > 1 ? "s" : ""} envoyée${sent > 1 ? "s" : ""}` : `${stats.surveysCount ?? 0} questionnaire${(stats.surveysCount ?? 0) > 1 ? "s" : ""}`}</small>
            </div>
            <div className="sat-kpi">
                <span>Taux de réponse</span>
                <strong>{formatRate(stats.responseRate)}</strong>
                {stats.startedCount != null && <small>{stats.startedCount} commencé{stats.startedCount > 1 ? "s" : ""}</small>}
            </div>
        </div>
    );
}
